export default __webpack_public_path__ + "static/media/(3)-Dupla.1930bbb9.jpg";